<template>
    <vue-editor
            :editorOptions="editorOptions"
            v-model="editorDataContent"></vue-editor>
</template>

<script>
    import {VueEditor} from 'vue2-editor';

    export default {
        name: 'CustomTextEditor',
        components: {
            VueEditor
        },

        props: ['value'],

        data() {
            return {
                editorOptions: {
                    modules: {
                        toolbar: {
                            container: [
                                [{ 'header': 1 }, { 'header': 2 }],
                                ['bold', 'italic', 'underline', 'strike'],
                                ['blockquote', 'code-block'],
                                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                [{ 'script': 'sub'}, { 'script': 'super' }],
                                [{ 'color': [] }, { 'background': [] }],
                                [{ 'align': [] }],
                                ['link','image','video']
                            ]
                        }
                    },
                },

                editorDataContent: '',
            }
        },

        watch: {
            value(val) {
                this.editorDataContent = val;
            },

            editorDataContent(val) {
                // Проброс значения наверх для v-model
                this.$emit('input', val);
            }
        }
    }
</script>
